import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useArticlesStore } from '@/stores/articles.ts';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesDetails',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const router = useRouter();
        const route = useRoute();
        const articlesStore = useArticlesStore();
        const __returned__ = { $t, router, route, articlesStore };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
